import { useCallback, useEffect, useState } from 'react'
import Helmet from '../../../../components/Helmet'
import HeaderContent from '../../../../components/Layouts/HeaderContent'
import { ContentWrapper } from '../../../../components/ContentWrapper'
import { useNavigate } from 'react-router-dom'
import queryString from 'query-string'
import dayjs from 'dayjs'
import PageUrls from '../../../../constants/page-urls'
import ReportFilter, { IFilterMapped } from '../../components/ReportFilter'
import { Card, Grid } from '@mui/material'
import CommissionReportTable from './components/CommissionReportTable'
import useAxios from '../../../../hooks/useAxios'
import { IUserOrderCancelledReport } from '../../../../types/report'
import { PaginationResponseInterface } from '../../../../types/pagination'
import CancelledOrderReportFilter from '../../components/CancelledOrderReportFilter'

const Menus: any[] = []

const CommissionCancelledReportPage = () => {
  const navigate = useNavigate()
  const queryStr = queryString.parse(window.location.search)

  const initFilters = {
    categoryObjectIds: queryStr.categoryObjectIds?.length
      ? String(queryStr.categoryObjectIds).split(',')
      : undefined,
    productObjectIds: queryStr.productObjectIds?.length
      ? String(queryStr.productObjectIds).split(',')
      : undefined,
    productGroups: queryStr.productGroups?.length
      ? String(queryStr.productGroups).split(',')
      : undefined,
    distributionObjectIds: queryStr.distributionObjectIds?.length
      ? String(queryStr.distributionObjectIds).split(',')
      : undefined,
    startDate: queryStr.startDate
      ? dayjs(String(queryStr.startDate)).startOf('day').format()
      : dayjs().subtract(30, 'days').format(),
    endDate: queryStr.endDate
      ? dayjs(String(queryStr.endDate)).startOf('day').format()
      : dayjs().format(),
    page: Number(queryStr.page ?? 1),
    perPage: 15,
    username: queryStr.username || undefined,
  }

  const [searchFilter, setSearchFilter] = useState<IFilterMapped>(initFilters)
  const [filter, setFilter] = useState<IFilterMapped>(initFilters)

  const onFilterChange = useCallback(
    (newFilter: IFilterMapped) => {
      setFilter(newFilter)
    },
    [setFilter],
  )

  const handleSearch = (newFilter: IFilterMapped) => {
    setFilter(newFilter)
    setSearchFilter(newFilter)
    const newQuery = queryString.stringify({ ...newFilter })
    navigate(`${PageUrls.Report.CommissionCancelled}?${newQuery}`, {
      replace: true,
    })
  }

  useEffect(() => {
    handleSearch(filter)
  }, [])

  const { data, isLoading } = useAxios<
    PaginationResponseInterface<IUserOrderCancelledReport>
  >({
    method: 'GET',
    url: '/report/order-cancelled-reports-logs',
    params: {
      ...searchFilter,
      shippingProvider:
        searchFilter.shippingProvider === 'all'
          ? undefined
          : searchFilter.shippingProvider,
    },
  })

  return (
    <ContentWrapper>
      <Helmet title="รายงานยกเลิกค่าคอมมิชชั่น" />
      <Grid container justifyContent="flex-start" alignItems="center">
        <Grid item>
          <HeaderContent
            goBack
            title={`รายงานยกเลิกค่าคอมมิชชั่น ${queryStr?.username || ''}`}
            // routes={Menus}
            descriptions="รายงานยกเลิกค่าคอมมิชชั่น"
          />
        </Grid>
      </Grid>

      <Card
        sx={{
          padding: 2,
        }}
      >
        <CancelledOrderReportFilter
          filter={filter}
          onFilterChange={onFilterChange}
          onSearch={handleSearch}
          showSippingProvider={false}
          showDistributionChannel={false}
          showCategory={false}
          showProduct={false}
          showDownload={false}
        />
        <CommissionReportTable
          isLoading={isLoading}
          data={data?.records}
          filter={filter}
          onFilterChange={handleSearch}
          total={data?.count || 0}
        />
      </Card>
    </ContentWrapper>
  )
}

export default CommissionCancelledReportPage
